import { render, staticRenderFns } from "./WatchSlot.vue?vue&type=template&id=01f805f4&scoped=true&"
import script from "./WatchSlot.vue?vue&type=script&lang=js&"
export * from "./WatchSlot.vue?vue&type=script&lang=js&"
import style0 from "./WatchSlot.vue?vue&type=style&index=0&id=01f805f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f805f4",
  null
  
)

export default component.exports